module.exports = __webpack_public_path__ + "87b144da3301e64f1e1ab196b8d07556.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-700.woff
// module id = 461
// module chunks = 0